@if (control) {
  <div class="number-container">
    @if (!disabled) {
      <input #number [ariaLabel]="label" type="text" [formControl]="control" [min]="min" [max]="max" (beforeinput)="onBeforeInput($event)" />
    } @else {
      <app-template-html [value]="value" [control]="control" />
    }
  </div>
}
